import { useCallback, useMemo } from "react";
import { SnowplowTracker } from "@/utils/snowplow_tracker";

export enum SnowplowEvent {
  SearchResultClicked = "mygreenhouse.job_search.result_clicked",
}

export const useSnowplowTracker = () => {
  const tracker = useMemo(() => new SnowplowTracker(), []);

  const trackEvent = useCallback(
    (eventName: string, data: Record<PropertyKey, string | number | undefined>) => {
      tracker &&
        tracker.track({
          name: eventName,
          data: {
            ...data,
            timestamp: Date.now(),
          },
        });
    },
    [tracker],
  );

  return { trackEvent };
};
